export default __webpack_public_path__ + "static/media/08ce4b5a2cf864fe6c737f9d92128d73.svg";